export default {
    addAdditionalProduct (state, payload) {
        state.additionalProducts.push(payload)
    },
    removeAdditionalProduct (state, insurer) {
        state.additionalProducts = state.additionalProducts.filter(additional => {
			return (additional.hasOwnProperty('company') ? additional.company.name : additional.seguradora) !== insurer
        })
    }
}


// WEBPACK FOOTER //
// ./src/shared/helpers/vuex/result/mutations.js